<template>
  <div>
    <hshead title="任务大厅" bgcolor="#fff" page="true"></hshead>
    <div class="order-ul">
      <van-list v-model="loading" :finished="finished" finished-text @load="onLoad">
        <div class="order-li" v-for="(item, index) in list" :key="index">
          <div class="content-box">
            <div class="content-top">
              <div class="left-img">
                <img src="~@/assets/images/order/icon.png" alt />
              </div>
              <div class="center-p">
                <div class="center-p-h1">{{item.storeFullName}}</div>
                <div class="center-p-p">{{item.createTimeTip}}</div>
              </div>
              <div class="right-icon">
                <router-link :to="`/Grapher/OrderDetail?orderId=${item.id}`">
                  <img src="~@/assets/images/order/ellipsis.png" alt />
                </router-link>
              </div>
            </div>
            <div class="content-content">
              <div class="left-p">
                {{item.productName}}
                <span>({{item.shootValue}}张)</span>
              </div>
              <div class="right-p">¥{{item.actualTotalMoney.toFixed(2)}}</div>
            </div>
            <div class="content-iconp iconp1">{{item.shootHotelName}}</div>
            <div class="content-iconp iconp2">{{item.shootAddress}}</div>
            <div class="content-iconp iconp3" v-if="item.productShootType != 1">{{item.plantStartDateing}}</div>
          </div>
          <div class="content-content">
            <!-- <router-link to class="li-btn">我要接单</router-link> -->
            <!-- <div style="font-size:initial;">{{item.orderUserName}} 于 {{item.createTime}} 发布任务</div> -->
            <!-- <div>
              <van-button plain hairline type="info" size="mini" v-if="item.orderStatus == 1" @click="acceptTaskOrderConfirm(item)">我要接单</van-button>
            </div>-->
          </div>
          <div class="order-li-bt">
            <van-button
              class="this-btn btn1"
              @click="documentStandard(item)"
              v-if="item.documentUrl !=''"
              style="width:2rem;"
            >拍摄标准</van-button>
            <van-button
              class="this-btn btn1"
              @click="acceptTaskOrderConfirm(item)"
              v-if="item.orderStatus == 1"
              style="width:2rem;"
            >我要接单</van-button>
          </div>
        </div>
      </van-list>
      <div v-if="finished" class="emptyDataDiv">
        <div v-if="list.length==0">
          <van-icon name="info" />
          <p>暂无任务</p>
        </div>
        <div v-else>没有更多了</div>
      </div>
    </div>

    <div class="ref-box" @click="listQuery.pn=1;list=[];getTaskOrderPager()">
      <img src="~@/assets/images/order/Refresh.png" alt />
    </div>

    <!-- 确认接单 -->
    <van-dialog
      v-model="dialogAcceptTaskOrderFormVisible"
      title="确认接单信息"
      show-cancel-button
      @confirm="acceptTaskOrder"
    >
      <van-cell-group v-if="curSelectedRow">
        <van-cell title="拍摄酒店" :value="curSelectedRow.shootHotelName" />
        <van-cell title="拍摄地址" :value="curSelectedRow.shootAddress" />
        <van-cell
          title="预拍摄时间"
          :value="curSelectedRow.plantStartDateing + '至' + curSelectedRow.plantStartDateing"
        />
      </van-cell-group>
    </van-dialog>

     <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span style="color:#304378">任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_earnings.active : icon_earnings.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Order" icon="chart-trending-o">
        <span>我的订单</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_order.active : icon_order.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Center" icon="chart-trending-o">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_user.active : icon_user.inactive"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Toast, List, Button, Dialog, CellGroup, Cell, Icon ,Tabbar, TabbarItem } from "vant";
import { getTaskOrderPager, acceptTaskOrder } from "@/api/m/grapher";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//我的订单
import order_icon from "@/assets/images/center/nav-6.png";
import order_icon_act from "@/assets/images/center/nav-6-act.png";
//我的
import user_icon from "@/assets/images/center/nav-7.png";
import user_icon_act from "@/assets/images/center/nav-7-act.png";
//87371599
export default {
  name: "MissionHall",
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 10
      },
      curSelectedRow: null,
      //接单
      dialogAcceptTaskOrderFormVisible: false,
       icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_order: {
        active: order_icon_act,
        inactive: order_icon,
      },
      icon_user: {
        active: user_icon_act,
        inactive: user_icon,
      },
    };
  },
  methods: {
    onLoad() {
      this.getTaskOrderPager();
    },
    //列表数据
    getTaskOrderPager() {
      getTaskOrderPager(this.listQuery)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getTaskOrderPager -> data", data);
            this.listQuery.pn = this.listQuery.pn + 1;
            //
            if (data.totalRecord == 0) {
              this.loading = false;
              this.finished = true;
            } else {
              data.list.map(item => {
                this.list.push(item);
              });
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.list.length >= data.totalRecord) {
                this.finished = true;
              }
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //接任务
    acceptTaskOrderConfirm(row) {
      this.curSelectedRow = row;
      this.dialogAcceptTaskOrderFormVisible = true;
    },
    documentStandard(row) {
      if (row.documentUrl != "") {
        sessionStorage.setItem("_documentUrl", row.documentUrl);
        window.location.href = "/static/pdfShow.html";
        // var u = navigator.userAgent,
        //   app = navigator.appVersion;
        // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // if (isAndroid) {
        //   //这个是安卓操作系统
        //   window.location.href = row.documentUrl;
        // }
        // if (isIOS) {
        //   sessionStorage.setItem("_documentUrl", row.documentUrl);
        //   window.location.href = "/static/pdfShow.html";
        //   //这个是ios操作系统
        // }
      }
    },
    acceptTaskOrder() {
      this.load(true, "加载中...");
      let para = {
        orderId: this.curSelectedRow.id
      };
      acceptTaskOrder(para)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`接单成功`);
            //this.listQuery.pn = 1;
            //this.getTaskOrderPager();
            setTimeout(function() {
              window.location.href = window.location.href;
            }, 1000 * 1);
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    }
  },
  created: function() {},
  components: {
    hshead,
    "van-list": List,
    "van-button": Button,
    //"van-dialog": Dialog.Component,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-icon": Icon,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.order-ul {
  margin-top: -6.2rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    position: relative;
    .content-box {
      padding: 0.47rem 0.3rem;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-content {
        display: flex;
        .left-p {
          width: 100%;
          font-family: PingFangSC-Medium;
          font-size: 0.3rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        &.iconp1 {
          background: url(~@/assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(~@/assets/images/order/2.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(~@/assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
    }
    .li-btn {
      position: absolute;
      bottom: 0.4rem;
      right: 0.3rem;
      width: 1.7rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      border: solid 1px #00b8f5;
      font-size: 0.24rem;
      text-align: center;
      color: #00b8f5;
      line-height: 0.6rem;
      &:active {
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#f2f9fb, #f2f9fb);
        background-blend-mode: normal, normal;
        color: #fff;
      }
    }
    .order-li-bt {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .this-btn {
        width: 1.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 1px #00b8f5;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #00b8f5;
        text-align: center;
        display: block;
        margin: 0 0.3rem;
        &.btn1 {
        }
        &.btn2 {
          background-color: #00b8f5;
          color: #fff;
        }
      }
    }
  }
}
.van-dialog__content {
  padding-top: 10px;
}
.replacerapher .van-dialog__content {
  height: 80%;
}
.grapher-ul {
  width: 100%;
  height: 65%;
  overflow: scroll;
  position: absolute;
  .van-list {
    width: 100%;
  }
  .grapher-li {
    border: 1px solid #f0f6ef;
    padding: 4px 0px;
    font-size: 0.8em;
  }
  .van-loading {
    display: none;
  }
}
.dialog-lshoot-close {
  position: fixed;
  top: 0;
  right: 0;
  font-size: 1.5em;
  color: #ff0000;
}
.ref-box {
  position: fixed;
  right: 0.2rem;
  bottom: 0.2rem;
  opacity: 0.3;
  img {
    width: 1rem;
  }
  &:active {
    opacity: 0.6;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/MissionHall.vue